import { toast } from "react-toastify";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
// const { persist, purge } = configurePersist({
//   storage: localStorage, // use `AsyncStorage` in react native
//   rootKey: "root", // optional, default value is `root`
// });

export const useMapStore = create(
    persist(
        (set) => ({
            storeWaypoints: null,
            setWaypoints: (points) => {
                set({ storeWaypoints: points });
            },
            missionPlanningWaypoints: null,
            setMissionPlanningWaypoints: (points) => {
                set({ missionPlanningWaypoints: points })
            },
            userDronesIdsStore: [],
            setUserDronesIdsStore: (dronesIdArray) => {
                set({ userDronesIdsStore: dronesIdArray })
            },
            storeZones: {},
            setStoreZones: (zonesArray) => {
                set({ zones: zonesArray })
            },
            showAirSpaceDroneInfo: false,
            setShowAirspaceDroneInfo: (bool) => {
                set({ showAirSpaceDroneInfo: bool })
            },
            showMissionPlanningPopup: false,
            setShowMissionPlanningPopup: (bool) => {
                set({ showMissionPlanningPopup: bool })
            },
            showZoneInfo: false,
            setShowZoneInfoPopup: (bool) => {
                set({ showZoneInfo: bool })
            },
            zoneInfo: [],
            setZoneInfo: (data) => {
                set({ zoneInfo: data })
            }
        }),
        {
            name: "mapWaypoints-storage",
            storage: createJSONStorage(() => localStorage),
        }
    )
);

// export default useAuthStore;
